module.exports = __webpack_public_path__ + "static/media/go-big-go-home-banner.01c92f98.webp";